/**
 * @module events/types/keyUp
 */

/**
 * @type {string}
 */
export default 'keyup'
